var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("form", { on: { submit: _setup.onSubmitHandler } }, [
    _c(
      "div",
      { staticClass: "pm-list-form" },
      [
        _c("v-autocomplete", {
          attrs: {
            disabled: _setup.pmTemplateState.isLoading,
            label: "Form No",
            dense: "",
            outlined: "",
            "hide-details": "auto",
            filter: _setup.pmTemplateFilter,
            items: _setup.pmTemplateState.items,
            "return-object": "",
            loading: _setup.pmTemplateState.isLoading
          },
          scopedSlots: _vm._u([
            {
              key: "selection",
              fn: function({ item }) {
                return [
                  _c("div", { style: { textTransform: "uppercase" } }, [
                    _vm._v(" " + _vm._s(item.formNo) + " ")
                  ])
                ]
              }
            },
            {
              key: "item",
              fn: function({ item }) {
                return [
                  _c("div", { style: { textTransform: "uppercase" } }, [
                    _vm._v(_vm._s(item.formNo))
                  ])
                ]
              }
            }
          ]),
          model: {
            value: _setup.pmTemplateState.selected,
            callback: function($$v) {
              _vm.$set(_setup.pmTemplateState, "selected", $$v)
            },
            expression: "pmTemplateState.selected"
          }
        }),
        _c("v-text-field", {
          attrs: {
            dense: "",
            outlined: "",
            "hide-details": "auto",
            "error-messages": _setup.formState.errors.title,
            label: "Title"
          },
          model: {
            value: _setup.formState.data.title,
            callback: function($$v) {
              _vm.$set(_setup.formState.data, "title", $$v)
            },
            expression: "formState.data.title"
          }
        }),
        _c("v-text-field", {
          attrs: {
            dense: "",
            outlined: "",
            "hide-details": "auto",
            "error-messages": _setup.formState.errors.formNo,
            label: "Form No"
          },
          model: {
            value: _setup.formState.data.formNo,
            callback: function($$v) {
              _vm.$set(_setup.formState.data, "formNo", $$v)
            },
            expression: "formState.data.formNo"
          }
        }),
        _c("v-combobox", {
          attrs: {
            dense: "",
            outlined: "",
            loading: _setup.equipmentNameList.isLoading,
            items: _setup.equipmentNameList.items,
            "hide-details": "auto",
            "error-messages": _setup.formState.errors.name,
            placeholder: "example: H1",
            label: "Equipment Name"
          },
          model: {
            value: _setup.formState.data.name,
            callback: function($$v) {
              _vm.$set(_setup.formState.data, "name", $$v)
            },
            expression: "formState.data.name"
          }
        }),
        _c("v-text-field", {
          attrs: {
            dense: "",
            outlined: "",
            "hide-details": "auto",
            "error-messages": _setup.formState.errors.equipment,
            label: "Equipment"
          },
          model: {
            value: _setup.formState.data.equipment,
            callback: function($$v) {
              _vm.$set(_setup.formState.data, "equipment", $$v)
            },
            expression: "formState.data.equipment"
          }
        }),
        _c("v-combobox", {
          attrs: {
            dense: "",
            outlined: "",
            loading: _setup.clientList.isLoading,
            items: _setup.clientList.items,
            "hide-details": "auto",
            "error-messages": _setup.formState.errors.client,
            label: "Client"
          },
          model: {
            value: _setup.formState.data.client,
            callback: function($$v) {
              _vm.$set(_setup.formState.data, "client", $$v)
            },
            expression: "formState.data.client"
          }
        }),
        _c("v-text-field", {
          attrs: {
            dense: "",
            outlined: "",
            "hide-details": "auto",
            type: "datetime-local",
            label: "Date Conducted",
            "error-messages": _setup.formState.errors.dateConducted
          },
          model: {
            value: _setup.formState.data.dateConducted,
            callback: function($$v) {
              _vm.$set(_setup.formState.data, "dateConducted", $$v)
            },
            expression: "formState.data.dateConducted"
          }
        }),
        _setup.props.editId
          ? _c("v-textarea", {
              attrs: {
                dense: "",
                outlined: "",
                "error-messages": _setup.formState.errors.remarks,
                rows: 5,
                label: "Further Remarks"
              },
              model: {
                value: _setup.formState.data.remarks,
                callback: function($$v) {
                  _vm.$set(_setup.formState.data, "remarks", $$v)
                },
                expression: "formState.data.remarks"
              }
            })
          : _vm._e(),
        _setup.props.editId
          ? _c(
              "div",
              { staticClass: "actions" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      loading: _setup.formState.isLoading,
                      disabled: _setup.formState.isLoading,
                      color: "warning",
                      type: "submit",
                      php: ""
                    }
                  },
                  [_vm._v("Update")]
                ),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "error", type: "button" },
                    on: { click: _setup.onCancelHandler }
                  },
                  [_vm._v("Close")]
                )
              ],
              1
            )
          : _c(
              "v-btn",
              {
                attrs: {
                  color: "primary",
                  loading: _setup.formState.isLoading,
                  disabled: _setup.formState.isLoading,
                  dark: "",
                  type: "submit"
                }
              },
              [_vm._v("Submit")]
            )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }